import { DevToolsMicroLabel } from 'Modules/softphone/components/SoftphoneDevTools/DevToolsMicroLabel';
import { DevToolsStatusBadge } from 'Modules/softphone/components/SoftphoneDevTools/DevToolsStatusBadge';
import type { TransferLegProps } from 'Modules/softphone/components/SoftphoneDevTools/DevToolsTabs/CallsTab/CallsTransferStatus/TransferLeg/index.types';
import React from 'react';
import { cn } from '~/lib/utils';

/** One half of the operation: which leg it is, and the call id carrying it. */
export const TransferLeg: React.FC<TransferLegProps> = ({
  role,
  id,
  missing,
  isVoicemail,
}) => (
  <div className="min-w-0">
    <div className="flex items-center gap-1.5">
      <DevToolsMicroLabel>{role}</DevToolsMicroLabel>
      {isVoicemail && (
        <DevToolsStatusBadge label="voicemail" variant="warning" />
      )}
    </div>
    <div
      className={cn(
        'mt-0.5 truncate text-[11px]',
        id ? 'font-sp-mono text-zinc-300' : 'text-zinc-400'
      )}
    >
      {id ?? missing}
    </div>
  </div>
);
